import {NgModule} from '@angular/core';
import {SharedProviderModule} from '../../../shared/shared.module';
import {TrainInfoComponent} from './train-info/train-info.component';
import {TrainScheduleComponent} from './train-schedule/train-schedule.component';
import {TrainDetailsComponent} from './train-details/train-details.component';
import {NgbDatepickerModule, NgbTabsetModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {TrainDependenciesComponent} from './train-dependencies/train-dependencies.component';
import {ElementDetailsModule} from '../../../element-details/element-details.module';
import {GoogleChartsModule} from '../../../components/google-charts/google-charts.module';
import {TrainHoverComponent} from './train-hover/train-hover.component';
import {TrainCompositionsComponent} from './train-compositions/train-compositions.component';
import {CargoManifestComponent} from './cargo-manifest/cargo-manifest.component';
import {OverlayPanelModule} from '../../../components/overlay-panel/overlay-panel.module';
import {QmPipesModule} from '../../../components/qm-pipes/qm-pipes.module';
import {ElementUtilsModule} from '../../../element-utils/element-utils.module';
import {WorkshiftTimelineModule} from '../workshift-timeline/workshift-timeline.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { TrainPersonnelModule } from '../train-personnel/train-personnel.module';

@NgModule({
  imports: [
    GoogleChartsModule,
    ElementDetailsModule,
    NgbTabsetModule,
    SharedProviderModule,
    OverlayPanelModule,
    QmPipesModule,
    ElementUtilsModule,
    WorkshiftTimelineModule,
    FontAwesomeModule,
    TrainPersonnelModule,
    NgbDatepickerModule,
    NgbTooltipModule
  ],
  declarations: [TrainInfoComponent, TrainScheduleComponent, TrainDetailsComponent,
    TrainDependenciesComponent, TrainCompositionsComponent, TrainHoverComponent,
    CargoManifestComponent],
  exports: [TrainInfoComponent, TrainScheduleComponent, TrainDetailsComponent,
    TrainCompositionsComponent, TrainHoverComponent]
})
export class TrainInfoModule {
}
